<template>
    <div class="container-fluid p-admin-coupons">
        <div class="card">
            <div class="card-header">クーポン一覧</div>

            <div class="card-body pt-2">
                <div class="d-block d-md-flex justify-content-between align-items-center mb-3">
                    <div class="d-block d-md-flex flex-wrap align-items-center">
                        <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                            <div class="input-group input-group-sm">
                                <select
                                    v-model="search.category"
                                    @change="onChangeSearchCategory"
                                    class="form-control">
                                    <option :value="null">タイプで検索</option>
                                    <option :value="couponCategory.consultation">{{ $locale.consultation_host }}</option>
                                    <option :value="couponCategory.plan">サービス</option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                            <div class="input-group input-group-sm">
                                <select
                                    v-model="search.doctor_id"
                                    @change="onChangeSearchDoctor"
                                    class="form-control">
                                    <option :value="null">対象医師で検索</option>
                                    <option
                                        v-for="doctor in doctors"
                                        :value="doctor.id">
                                        {{ doctor.full_name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                            <div class="c-freeword input-group input-group-sm">
                                <input
                                    v-model="search.freeword"
                                    @blur="onChangeSearchFreeword"
                                    type="text"
                                    class="form-control"
                                    placeholder="フリーワード"
                                    style="min-width: 100px;">
                                <div class="input-group-append">
                                    <div
                                        class="c-freeword__btn input-group-text"
                                        @click="onChangeSearchFreeword">
                                        検索
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex align-items-center">
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <span class="small">取得期限</span>
                            </div>
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchGetExpireDayAtGte"
                                        style="min-width: 100px;"
                                        v-model="search.get_expire_day_at_gte">
                                </div>
                            </div>
                            <span class="small mt-2 ml-2">〜</span>
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchGetExpireDayAtLte"
                                        style="min-width: 100px;"
                                        v-model="search.get_expire_day_at_lte">
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex align-items-center">
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <span class="small">使用期限</span>
                            </div>
                            <div class="mt-2 mb-2 ml-md-2 mb-md-0">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchExpireDayAtGte"
                                        style="min-width: 100px;"
                                        v-model="search.expire_day_at_gte">
                                </div>
                            </div>
                            <span class="small mt-2 ml-2">〜</span>
                            <div class="mt-2 mb-2 ml-md-2 mr-md-3 mb-md-0">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        type="date"
                                        class="form-control"
                                        @change="onChangeSearchExpireDayAtLte"
                                        style="min-width: 100px;"
                                        v-model="search.expire_day_at_lte">
                                </div>
                            </div>
                        </div>
                        <div class="pt-1 mt-2 mr-0 mb-2 mb-md-0">
                            <div class="input-group input-group-sm">
                                <div class="custom-control custom-checkbox">
                                    <input
                                        v-model="search.is_only_matching"
                                        @change="onChangeSearchIsOnlyMatching"
                                        type="checkbox"
                                        id="search_is_only_matching"
                                        name="search_is_only_matching"
                                        class="custom-control-input">
                                    <label
                                        class="custom-control-label"
                                        for="search_is_only_matching">
                                        マッチング予約のみ利用可能なクーポンを表示
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end">
                        <button
                            type="button"
                            class="btn btn-yokumiru-orange mt-2"
                            style="min-width: 120px; margin-left: auto;"
                            @click="openModalAdminAddCoupon">
                            クーポン追加
                        </button>
                    </div>
                </div>

                <div
                    v-if="inProgress && coupons === null"
                    class="p-5 d-flex justify-content-center align-items-center">
                    <b-spinner variant="yokumiru-admin"/>
                </div>
                <div
                    v-show="coupons !== null"
                    class="row justify-content-center">
                    <div class="col-md-12">
                        <b-table
                            striped
                            hover
                            :items="coupons"
                            :fields="fields"
                            :sort-by.sync="$store.state.adminCoupons.sortBy"
                            :sort-desc.sync="$store.state.adminCoupons.sortDesc"
                            @sort-changed="fetchCoupons"
                            responsive
                            class="table-bordered m-table">
                            <template v-slot:cell(name)="data">
                                <div>{{ data.item.name }}</div>
                                <div class="small text-muted">{{ data.item.campaign.name }}</div>
                                <div
                                    v-if="data.item.is_only_matching"
                                    class="isOnlyMatching">
                                    マッチング予約のみ
                                </div>
                            </template>

                            <template v-slot:cell(category)="data">
                                <div>{{ couponCategoryFormat(data.item) }}</div>
                            </template>

                            <template v-slot:cell(discount)="data">
                                <span>{{ discountFormat(data.item) }}</span>
                            </template>

                            <template v-slot:cell(get_expire_day_at)="data">
                                <template v-if="data.item.get_expire_day_at">
                                    <div class="u-palt">
                                    <span>
                                        {{ helper.dateForHuman(data.item.get_expire_day_at, 'Asia/Tokyo', {simpleYear: true}) }}
                                    </span>
                                        <span
                                            class="font-weight-bold"
                                            :class="helper.dayForHumanCSS(data.item.get_expire_day_at , 'Asia/Tokyo')">
                                        {{ helper.dayForHuman(data.item.get_expire_day_at, 'Asia/Tokyo', {bracket: true}) }}
                                    </span>
                                        <span>{{ helper.timeForHuman(data.item.get_expire_day_at, 'Asia/Tokyo') }}</span>
                                    </div>
                                </template>
                                <template v-else-if="data.item.get_expire_days">
                                    <span>{{ `発行後${data.item.get_expire_days}日間` }}</span>
                                </template>
                                <template v-else>
                                    <span>{{ `${$locale.patient}登録後${data.item.get_expire_registration_days}` }}日間</span>
                                </template>
                            </template>

                            <template v-slot:cell(expire_day_at)="data">
                                <template v-if="data.item.expire_day_at">
                                    <div class="u-palt">
                                    <span>
                                        {{ helper.dateForHuman(data.item.expire_day_at, 'Asia/Tokyo', {simpleYear: true}) }}
                                    </span>
                                        <span
                                            class="font-weight-bold"
                                            :class="helper.dayForHumanCSS(data.item.expire_day_at , 'Asia/Tokyo')">
                                        {{ helper.dayForHuman(data.item.expire_day_at, 'Asia/Tokyo', {bracket: true}) }}
                                    </span>
                                        <span>{{ helper.timeForHuman(data.item.expire_day_at, 'Asia/Tokyo') }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <span>{{ `取得後${data.item.expire_days}日間` }}</span>
                                </template>
                            </template>

                            <template v-slot:cell(doctors)="data">
                                <div v-if="data.item.doctors.length > 0">
                                    <a
                                        v-for="doctor in data.item.doctors"
                                        href="#"
                                        class="d-block"
                                        @click="openModalDoctorProfile(doctor.id, $event)">
                                        {{ doctor.full_name }}
                                    </a>
                                </div>
                                <div v-else>-</div>
                            </template>

                            <template v-slot:cell(doctor_menus)="data">
                                <div v-if="data.item.doctor_menus.length > 0">
                                    <a
                                        v-for="doctorMenu in data.item.doctor_menus"
                                        href="#"
                                        class="d-block"
                                        @click="showModalDoctorMenu(doctorMenu.id)">
                                        {{ `${doctorMenu.title}（${doctorMenu.doctor ? doctorMenu.doctor.full_name : '退会済の医師'}）` }}
                                    </a>
                                </div>
                                <div v-else>-</div>
                            </template>

                            <template v-slot:cell(min_consultation_price)="data">
                                <span v-if="data.item.min_consultation_price !== null">
                                    {{ data.item.min_consultation_price.toLocaleString() }}円
                                </span>
                                <span v-else>-</span>
                            </template>

                            <template v-slot:cell(links)="data">
                                <b-button
                                    type="button"
                                    variant="yokumiru-blue"
                                    class="btn-sm m-2"
                                    @click="openModalAdminEditCoupon(data.item)">
                                    編集
                                </b-button>
                                <b-button
                                    type="button"
                                    variant="danger"
                                    class="btn-sm m-2"
                                    :disabled="data.item.publish_count > 0"
                                    @click="openModalAdminDeleteCoupon(data.item)">
                                    削除
                                </b-button>
                            </template>
                        </b-table>

                        <div class="d-flex flex-wrap justify-content-between align-items-center">
                            <b-pagination
                                :total-rows="$store.state.adminCoupons.total"
                                :per-page="$store.state.adminCoupons.per_page"
                                v-model="$store.state.adminCoupons.current_page"
                                @change="fetchCoupons">
                            </b-pagination>

                            <div class="d-flex flex-wrap align-items-center">
                                <div class="mr-3 mb-3">
                                    <span class="small">{{ dispPaginationDetail }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-if="doctors !== null && doctorMenus !== null && plans !== null">
            <admin-add-coupon-modal
                :doctors="doctors"
                :doctor-menus="doctorMenus"
                :plans="plans"
            />
            <admin-edit-coupon-modal
                :doctors="doctors"
                :doctor-menus="doctorMenus"
                :plans="plans"
            />
        </template>

        <admin-delete-coupon-modal/>
        <admin-doctor-profile-modal/>
        <doctor-menu-modal user-type="admin"/>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import constants from '../../constants'
import YokumiruHelper from '../../YokumiruHelper'

export default {
    name: 'AdminCoupons',

    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            couponCategory: constants.couponCategory,
            search: {
                freeword: null,
                doctor_id: null,
                category: null,
                get_expire_day_at_gte: null,
                get_expire_day_at_lte: null,
                expire_day_at_gte: null,
                expire_day_at_lte: null,
                is_only_matching: false,
            },
            coupons: null,
            doctors: null,
            doctorMenus: null,
            plans: null,
            medicalCourses: null,
            fields: [
                {
                    'key': 'id',
                    'label': '#',
                    sortable: true,
                },
                {
                    'key': 'name',
                    'label': 'クーポン名',
                    sortable: true,
                },
                {
                    'key': 'category',
                    'label': 'タイプ',
                    sortable: true,
                },
                {
                    'key': 'discount',
                    'label': '割引',
                    sortable: true,
                },
                {
                    'key': 'get_expire_day_at',
                    'label': '取得期限',
                    sortable: true,
                },
                {
                    'key': 'expire_day_at',
                    'label': '使用期限',
                    sortable: true,
                },
                {
                    'key': 'use_count',
                    'label': '使用数',
                    sortable: true,
                },
                {
                    'key': 'get_count',
                    'label': '取得数',
                    sortable: true,
                },
                {
                    'key': 'publish_count',
                    'label': '発行数',
                    sortable: true,
                },
                {
                    'key': 'doctors',
                    'label': '対象医師',
                    sortable: false,
                },
                {
                    'key': 'doctor_menus',
                    'label': '対象メニュー',
                    sortable: false,
                },
                {
                    'key': 'min_consultation_price',
                    'label': '最低利用金額',
                    sortable: true,
                },
                {
                    'key': 'links',
                    'label': '',
                    'class': 'text-center',
                    sortable: false,
                },
            ],
        }
    },

    computed: {
        /**
         * ページング詳細表示
         * @returns {string}
         */
        dispPaginationDetail: function () {
            if (this.$store.state.adminCoupons.total < 1) {
                return ''
            }

            return `全${this.$store.state.adminCoupons.total}件中 ${this.$store.state.adminCoupons.from}～${this.$store.state.adminCoupons.to}件表示`
        },
    },

    created: function () {
        this.initQueryFromState()
        this.initSearchCondition()

        this.fetchDoctors()
        this.fetchDoctorMenus()
        this.fetchPlans()
        this.fetchMedicalCourses()
        this.fetchCoupons()

        bus.$on('coupon-added', this.fetchCoupons)
        bus.$on('coupon-edited', this.fetchCoupons)
        bus.$on('coupon-deleted', this.fetchCoupons)
    },

    beforeDestroy: function () {
        bus.$off('coupon-added')
        bus.$off('coupon-edited')
        bus.$off('coupon-deleted')
    },

    methods: {
        ...mapMutations({
            setQuery: 'adminCoupons/setQuery',
            setQueries: 'adminCoupons/setQueries',
        }),

        onChangeSearchFreeword: async function () {
            await this.setQuery({ key: 'freeword', value: this.search.freeword })
            await this.fetchCoupons(1)
        },

        onChangeSearchDoctor: async function () {
            await this.setQuery({ key: 'doctor_id', value: this.search.doctor_id })
            await this.fetchCoupons(1)
        },

        onChangeSearchCategory: async function () {
            await this.setQuery({ key: 'category', value: this.search.category })
            await this.fetchCoupons(1)
        },

        onChangeSearchGetExpireDayAtGte: async function () {
            await this.setQuery({ key: 'get_expire_day_at_gte', value: this.search.get_expire_day_at_gte })
            await this.fetchCoupons(1)
        },

        onChangeSearchGetExpireDayAtLte: async function () {
            await this.setQuery({ key: 'get_expire_day_at_lte', value: this.search.get_expire_day_at_lte })
            await this.fetchCoupons(1)
        },

        onChangeSearchExpireDayAtGte: async function () {
            await this.setQuery({ key: 'expire_day_at_gte', value: this.search.expire_day_at_gte })
            await this.fetchCoupons(1)
        },

        onChangeSearchExpireDayAtLte: async function () {
            await this.setQuery({ key: 'expire_day_at_lte', value: this.search.expire_day_at_lte })
            await this.fetchCoupons(1)
        },

        onChangeSearchIsOnlyMatching: async function () {
            await this.setQuery({ key: 'is_only_matching', value: this.search.is_only_matching })
            await this.fetchCoupons(1)
        },

        /**
         * 医師メニュー詳細モーダル表示
         *
         * @param {number} doctor_menu_id
         */
        showModalDoctorMenu: function (doctor_menu_id) {
            bus.$emit('open-modal-doctor-menu', doctor_menu_id)
        },

        /**
         * クーポンマスタ一覧取得
         *
         * @param {number|object} param
         */
        fetchCoupons: async function (param = null) {
            if (this.inProgress) return
            this.inProgress = true

            this.coupons = null

            if (Number.isInteger(param) && param > 0) {
                await this.setQuery({ key: 'current_page', value: param })
            }
            else if (param !== null && param.hasOwnProperty('sortBy')) {
                await this.setQuery({ key: 'sortBy', value: param.sortBy })
                await this.setQuery({ key: 'sortDesc', value: param.sortDesc })
            }

            const endpoint = constants.admin.coupons.endpoint.base

            await axios.get(`${endpoint}${this.buildQuery()}`)
                .then(({data}) => {
                    this.coupons = data.data
                    this.setQueries(data.meta)
                })

            this.inProgress = false
        },

        /**
         * 医師一覧取得
         */
        fetchDoctors: function () {
            axios.get(`${constants.admin.doctors.endpoint.all}`)
                .then(({data}) => {
                    this.doctors = data
                })
        },

        /**
         * 医師メニュー一覧取得
         */
        fetchDoctorMenus: function () {
            axios.get(constants.admin.doctor_menus.endpoint.base)
                .then(({data}) => {
                    this.doctorMenus = data.data
                })
        },

        /**
         * サービスモデル一覧取得
         */
        fetchPlans: function () {
            const endpoint = constants.admin.plans.endpoint.base

            let query = `?except_keys[]=${constants.plans.payPer}`
            query += `&except_keys[]=${constants.plans.travelFree}`
            query += `&except_keys[]=${constants.plans.studyAbroadFree}`

            axios.get(`${endpoint}${query}`)
                .then(({data}) => {
                    this.plans = data.data
                })
        },

        /**
         * 相談科一覧取得
         */
        fetchMedicalCourses: function () {
            axios.get(constants.admin.medical_courses.endpoint.base)
                .then(({data}) => {
                    this.medicalCourses = data
                })
        },

        /**
         * 検索条件の初期化（localStorageから復元）
         */
        initQueryFromState: function () {
            if (localStorage.getItem('yokumiruWeb')) {
                const data = JSON.parse(localStorage.getItem('yokumiruWeb'))
                if (data.adminCoupons) {
                    this.setQueries(data.adminCoupons)
                }
            }
        },

        /**
         * 検索条件の初期化
         */
        initSearchCondition: function () {
            this.search.freeword = this.$store.state.adminCoupons.freeword
            this.search.doctor_id = this.$store.state.adminCoupons.doctor_id
            this.search.category = this.$store.state.adminCoupons.category
            this.search.get_expire_day_at_gte = this.$store.state.adminCoupons.get_expire_day_at_gte
            this.search.get_expire_day_at_lte = this.$store.state.adminCoupons.get_expire_day_at_lte
            this.search.expire_day_at_gte = this.$store.state.adminCoupons.expire_day_at_gte
            this.search.expire_day_at_lte = this.$store.state.adminCoupons.expire_day_at_lte
            this.search.is_only_matching = this.$store.state.adminCoupons.is_only_matching
        },

        /**
         * QueryString生成
         *
         * @param {boolean} paginate
         * @return {string}
         */
        buildQuery: function (paginate = true) {
            let query = '?'

            if (paginate) {
                query += `page=${this.$store.state.adminCoupons.current_page}`
                query += `&sort=${this.$store.state.adminCoupons.sortBy}`
                query += `&desc=${this.$store.state.adminCoupons.sortDesc}`
            }
            else {
                query += `sort=${this.$store.state.adminCoupons.sortBy}`
                query += `&desc=${this.$store.state.adminCoupons.sortDesc}`
            }

            query += `&freeword=${this.$store.state.adminCoupons.freeword || ''}`
            query += `&doctor_id=${this.$store.state.adminCoupons.doctor_id || ''}`
            query += `&category=${this.$store.state.adminCoupons.category || ''}`
            query += `&get_expire_day_at_gte=${this.$store.state.adminCoupons.get_expire_day_at_gte || ''}`
            query += `&get_expire_day_at_lte=${this.$store.state.adminCoupons.get_expire_day_at_lte || ''}`
            query += `&expire_day_at_gte=${this.$store.state.adminCoupons.expire_day_at_gte || ''}`
            query += `&expire_day_at_lte=${this.$store.state.adminCoupons.expire_day_at_lte || ''}`
            query += `&is_only_matching=${this.$store.state.adminCoupons.is_only_matching ? '1' : '0'}`

            return query
        },

        /**
         * クーポンタイプの表記
         *
         * @param {object} coupon
         * @return {string}
         */
        couponCategoryFormat: function (coupon) {
            if (coupon.category === constants.couponCategory.consultation) {
                return this.$locale.consultation_host
            }
            else if (coupon.category === constants.couponCategory.plan) {
                return 'サービス'
            }
            return ''
        },

        /**
         * 割引額を割引方式に従って表記
         *
         * @param {object} coupon
         * @return {string}
         */
        discountFormat: function (coupon) {
            let format = coupon.discount.toLocaleString()

            if (coupon.discount_unit === 'percent') {
                return `${format}%`
            }
            else if (coupon.discount_unit === 'static') {
                return `${format}円`
            }
            else if (coupon.discount_unit === 'daily') {
                return `${format}円/日`
            }
            return format
        },

        /**
         * 医師詳細モーダル表示
         * @param {number} doctorId
         * @param {object} e
         */
        openModalDoctorProfile: function (doctorId, e) {
            e.preventDefault()
            bus.$emit('open-modal-admin-doctor-profile', doctorId)
        },

        /**
         * 追加モーダル表示
         */
        openModalAdminAddCoupon: function () {
            bus.$emit('open-modal-admin-add-coupon')
        },

        /**
         * 編集モーダル表示
         *
         * @param {object} coupon
         */
        openModalAdminEditCoupon: function (coupon) {
            bus.$emit('open-modal-admin-edit-coupon', coupon)
        },

        /**
         * 削除モーダル表示
         *
         * @param {object} coupon
         */
        openModalAdminDeleteCoupon: function (coupon) {
            bus.$emit('open-modal-admin-delete-coupon', coupon)
        },
    },
}
</script>

<style lang="scss" scoped>
.isOnlyMatching {
    display: inline-block;
    margin-top: 4px;
    padding: 3px 6px;
    color: #fff;
    font-size: 10px;
    background: #F892AA;
    border-radius: 5px;
}
</style>

<style lang="scss">
.p-admin-coupons table {
    font-size: 0.75rem;
}
</style>
